import React, { useState, useEffect, useCallback } from "react";
import apiService from "../services/apiService";
import { handleDeleteError, handleUpdateError, handleCreateError, handleToggleError } from "../utils/errorHandler";
import {
  Container,
  Typography,
  Button,
  Alert,
  Box,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Switch,
  Popover,
  Select,
  InputLabel,
  FormControl,
  Autocomplete,
  Paper,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlined from "@mui/icons-material/EditOutlined";
import ScheduleForm from "../Components/Schedule";
import SubStageForm from "../Components/Substage";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Table_theme from "../Themes/TableTheme";
import theme from "../Themes/FormThemes";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as Schedule } from "../Icons/Schedule.svg";
import { ReactComponent as Substage } from "../Icons/Substage.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import { ReactComponent as FlagIcon } from "../Icons/Flag.svg";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
function Jobs_panel() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    client_name: true,
    environment_name: true,
    application_name: true,
    logical_name: true,
    client_job_id: true,
    job_id: true,
    call_type: true,
    jobs_script: true,
    scope: true,
    criticality: true,
    reference_1: true,
    process_type: true,
    reference_2: true,
    log_file_loc: true,
    master_file: true,
    master_file_loc: true,
  });

    const compactMultilineStyles = {
    "& .MuiInputBase-root": {
      minHeight: "80px",
      fontSize: "0.85rem",
      padding: "0 10px",
    },
    "& .MuiInputBase-input": {
      padding: "8px 10px",
      lineHeight: "1.2",
      overflowY: "auto",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      top: "-2px",
    },
    "& .MuiInputLabel-shrink": {
      top: "0",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "0.875rem",
    },
  };

  const [formData, setFormData] = useState({
    cl_id: "",
    client_name: "",
    env_id: "",
    app_id: "",
    job_id: "",
    client_job_id: "",
    lg_id: "",
    criticality: "",
    call_type: "",
    jobs_script: "",
    frequency: "",
    scope: "",
    process_type: "",
    comments: "",
    active_flag: 1,
    reference_2: "",
    log_file_loc: "",
    master_file: "",
    master_file_loc: "",
  });
  const [filters, setFilters] = useState({
    client_name: "",
    environment_name: "",
    application_name: "",
    job_id: "",
    client_job_id: "",
    logical_name: "",
    criticality: "",
    call_type: "",
    jobs_script: "",
    reference_1: "",
    scope: "",
    process_type: "",
    reference_2: "",
    log_file_loc: "",
    master_file: "",
    master_file_loc: "",
  });

  // State for dropdown options
  const [clients, setClients] = useState([]);
  const [environments, setEnvironments] = useState([]);
  const [applications, setApplications] = useState([]);
  const [logicalGroups, setLogicalGroups] = useState([]);

  const [filterAnchorEls, setFilterAnchorEls] = useState({});
  const [tempFilters, setTempFilters] = useState({ ...filters });

  const handleFilterIconClick = (event, column) => {
    setFilterAnchorEls((prev) => ({ ...prev, [column]: event.currentTarget }));
  };

  const handleFilterClose = (column) => {
    setFilterAnchorEls((prev) => ({ ...prev, [column]: null }));
  };

  const applyFilter = (column) => {
    setFilters((prev) => ({ ...prev, [column]: tempFilters[column] }));
    handleFilterClose(column);
    setPage(1);
  };

  const clearFilter = (column) => {
    setTempFilters((prev) => ({ ...prev, [column]: "" }));
    setFilters((prev) => ({ ...prev, [column]: "" }));
    handleFilterClose(column);
    setPage(1);
  };

  const [formErrors, setFormErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openScheduleDialog, setOpenScheduleDialog] = useState(false);
  const [selectedJobForSchedule, setSelectedJobForSchedule] = useState(null);
  const [openSubstageDialog, setOpenSubstageDialog] = useState(false);
  const [selectedJobForSubstage, setSelectedJobForSubstage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedJobForDelete, setSelectedJobForDelete] = useState(null);
  const [originalFormData, setOriginalFormData] = useState({});
  const [isFormChanged, setIsFormChanged] = useState(false);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchNextJobId = async (app_id) => {
    if (!app_id) return "";
    try {
      const { next_job_id } = await apiService.get(
        `/jobs/max-job-id/${app_id}`,
      );
      return next_job_id.toString();
    } catch (err) {
      console.error(
        `Error fetching next job_id for app_id ${app_id}:`,
        err.message,
      );
      setErrorMessage(
        err.message || "Failed to fetch next job_id. Please try again.",
      );
      setTimeout(() => setErrorMessage(""), 3000);
      return "";
    }
  };
  // Fetch dropdown options
  const fetchClients = async () => {
    try {
      const data = await apiService.get("/jobs/clients");
      setClients(data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  const fetchEnvironments = async () => {
    try {
      const data = await apiService.get("/jobs/environments");
      setEnvironments(data);
    } catch (err) {
      console.error("Error fetching environments:", err);
    }
  };

  const fetchApplications = async (envId = null) => {
    try {
      let url = "/jobs/applications";
      if (envId) {
        url += `?env_id=${envId}`;
      }
      const data = await apiService.get(url);
      setApplications(data);
      return data;
    } catch (err) {
      console.error("Error fetching applications:", err);
      setApplications([]);
      return [];
    }
  };

  const fetchLogicalGroups = async (envId = null, appId = null) => {
    try {
      let url = "/jobs/logical-groups";
      const params = new URLSearchParams();
      if (envId) params.append("env_id", envId);
      if (appId) params.append("app_id", appId);
      if (params.toString()) url += `?${params.toString()}`;

      const data = await apiService.get(url);
      setLogicalGroups(data);
      return data;
    } catch (err) {
      console.error("Error fetching logical groups:", err);
      setLogicalGroups([]);
      return [];
    }
  };

  // Fetch jobs (existing function)
  const fetchJobs = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams({ page, limit: rowsPerPage });

    Object.entries(filters).forEach(([key, value]) => {
      if (value.trim() !== "") {
        params.append(key, value);
      }
    });

    if (searchTerm.trim() !== "") {
      params.append("search", searchTerm);
    }

    try {
      const result = await apiService.get(
        `/jobs/paginate/list?${params.toString()}`,
      );
      // Debug API response
      setData(result.data || []);
      setTotal(result.total || 0);
    } catch (err) {
      console.error("Error fetching jobs:", err);
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, filters, searchTerm]);

  // Pre-select first client when clients load
  useEffect(() => {
    if (clients.length > 0 && !formData.cl_id) {
      setFormData((prev) => ({
        ...prev,
        cl_id: clients[0].cl_id,
        client_name: clients[0].name,
      }));
    }
  }, [clients]);

  // Fetch dropdown options on component mount
  useEffect(() => {
    fetchClients();
    fetchEnvironments();
    fetchApplications(); // Load all applications initially
    fetchLogicalGroups(); // Load all logical groups initially
  }, []);

  // Fetch jobs when dependencies change
  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  // Track form changes for edit mode
  useEffect(() => {
    if (isEditing && Object.keys(originalFormData).length > 0) {
      const hasChanged = JSON.stringify(formData) !== JSON.stringify(originalFormData);
      setIsFormChanged(hasChanged);
    }
  }, [formData, originalFormData, isEditing]);

  const columnLabels = {
    client_name: "Client",
    environment_name: "Environment",
    application_name: "Application",
    logical_name: "Logical",
    job_id: "job ID",
    client_job_id: "Client Job ID",
    call_type: "Mode",
    criticality: "Criticality",
    jobs_script: "Jobs/Process Name",
    reference_1: "Frequency",
    scope: "Scope",
    process_type: "Process Type",
    reference_2: "Folder",
    log_file_loc: "Log File",
    master_file: "Master File",
    master_file_loc: "File Location",
    comments: "Comments",
  };

  const handleChange = (nameOrEvent, value) => {
    let name, newValue;
    if (typeof nameOrEvent === "string") {
      name = nameOrEvent;
      newValue = value;
    } else if (nameOrEvent && nameOrEvent.target) {
      ({ name, value: newValue } = nameOrEvent.target);
    } else {
      console.warn("Unexpected handleChange input:", nameOrEvent, value);
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: newValue }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEnvironmentChange = async (event, newValue) => {
    const envId = newValue ? newValue.env_id : "";
    setFormData((prev) => ({
      ...prev,
      env_id: envId,
      app_id: "", // Reset application when environment changes
      lg_id: "", // Reset logical group when environment changes
      job_id: "", // Reset job_id when environment changes
    }));
    setFormErrors((prev) => ({ ...prev, env_id: "" }));

    // Fetch applications for the selected environment
    if (envId) {
      await fetchApplications(envId);
    } else {
      setApplications([]);
    }

    // Clear dependent dropdowns
    setLogicalGroups([]);
  };

  const handleApplicationChange = async (event, newValue) => {
    const appId = newValue ? newValue.app_id : "";
    let newJobId = formData.job_id;

    // Auto-generate job ID for new jobs
    if (!isEditing && appId) {
      setLoading(true);
      newJobId = await fetchNextJobId(appId);
      setLoading(false);
    }

    setFormData((prev) => ({
      ...prev,
      app_id: appId,
      lg_id: "", // Reset logical group when application changes
      job_id: newJobId,
    }));
    setFormErrors((prev) => ({ ...prev, app_id: "" }));

    // Fetch logical groups for the selected environment and application
    if (formData.env_id && appId) {
      await fetchLogicalGroups(formData.env_id, appId);
    } else {
      setLogicalGroups([]);
    }
  };

  const validate = () => {
    const errors = {};
    
    // Field name mapping for error messages
    const fieldNames = {
      env_id: "Environment",
      app_id: "Application",
      job_id: "Job ID",
      lg_id: "Logical Group",
      criticality: "Criticality",
      jobs_script: "Job/Process Name",
      frequency: "Frequency",
      scope: "Scope",
      process_type: "Process Type",
      client_job_id: "Client Job ID",
      comments: "Comments",
      reference_2: "Folder",
      log_file_loc: "Log File",
      master_file: "Master File",
      master_file_loc: "Master File Location",
    };
    
    // Required fields validation
    const requiredFields = [
      "env_id",
      "app_id",
      "job_id",
      "lg_id",
      "criticality",
      "jobs_script",
      "frequency",
      "scope",
      "process_type",
    ];
    
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = `${fieldNames[field]} is required`;
      }
    });
    
    // Job ID validation - must be a number
    if (formData.job_id) {
      const jobIdNum = parseInt(formData.job_id, 10);
      if (isNaN(jobIdNum)) {
        errors.job_id = "Job ID must be a number";
      } else if (jobIdNum < 1000) {
        errors.job_id = "Job ID must be at least 1000";
      }
    }
    
    // Criticality validation - must be a number, no text allowed
    if (formData.criticality) {
      const criticalityNum = parseInt(formData.criticality, 10);
      if (isNaN(criticalityNum)) {
        errors.criticality = "Criticality must be a number";
      }
    }
    
    // Text field validations - no special characters only, must contain at least one letter
    const textFields = ['client_job_id', 'jobs_script', 'frequency', 'scope', 'process_type', 'comments', 'reference_2', 'log_file_loc', 'master_file', 'master_file_loc'];
    
    textFields.forEach((field) => {
      if (formData[field] && formData[field].trim()) {
        const value = formData[field].trim();
        
        // Check if it contains only special characters
        if (/^[^a-zA-Z0-9]+$/.test(value)) {
          errors[field] = `${fieldNames[field]} cannot contain only special characters`;
        }
        // Check if it contains at least one letter (for required text fields)
        else if (['jobs_script', 'frequency', 'scope', 'process_type'].includes(field) && !/[a-zA-Z]/.test(value)) {
          errors[field] = `${fieldNames[field]} must contain at least one letter`;
        }
      }
    });
    
    return errors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      // setErrorMessage("Please correct the errors in the form.");
      return;
    }

    const payload = {
      ...formData,
      job_id: parseInt(formData.job_id, 10),
      cl_id: formData.cl_id,
      env_id: formData.env_id,
      app_id: formData.app_id,
      lg_id: formData.lg_id,
      call_type: formData.call_type,
      reference_1: formData.frequency,
      error_tracking_flag: formData.error_tracking_flag || "N",
      active_flag: formData.active_flag ?? 1,
    };

    try {
      if (isEditing) {
        await apiService.put(`/jobs/${formData.job_id}`, payload);
      } else {
        await apiService.post("/jobs", payload);
      }
      setSuccessMessage(
        isEditing ? "Job updated successfully!" : "Job created successfully!",
      );
      resetFormData();
      fetchJobs();
      setTimeout(() => setSuccessMessage(""), 3000);
      handleDialogClose();
    } catch (err) {
      console.error("Error saving job:", err);
      // Use centralized error handler
      const errorMessage = isEditing 
        ? handleUpdateError(err, "Job")
        : handleCreateError(err, "Job");
      setErrorMessage(errorMessage);
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const resetFormData = () => {
    setFormData({
      cl_id: clients.length > 0 ? clients[0].cl_id : "",
      client_name: clients.length > 0 ? clients[0].name : "",
      env_id: "",
      app_id: "",
      job_id: "",
      client_job_id: "",
      lg_id: "",
      criticality: "",
      call_type: "",
      jobs_script: "",
      frequency: "",
      scope: "",
      process_type: "",
      comments: "",
      active_flag: 1,
      reference_2: "",
      log_file_loc: "",
      master_file: "",
      master_file_loc: "",
    });
    setIsEditing(false);
    setFormErrors({});

    // Clear dependent dropdowns when resetting
    setApplications([]);
    setLogicalGroups([]);
  };

  const handleEdit = async (job) => {
    setIsEditing(true);

    // First, load dependent data
    if (job.env_id) {
      await fetchApplications(job.env_id);
      if (job.app_id) {
        await fetchLogicalGroups(job.env_id, job.app_id);
      }
    }

    // Prepare the form data with proper transformations
    const editFormData = {
      cl_id: job.cl_id || "",
      client_name: job.client_name || "",
      env_id: job.env_id || "",
      app_id: job.app_id || "",
      job_id: job.job_id ? job.job_id.toString() : "",
      client_job_id: job.client_job_id || "",
      lg_id: job.lg_id || "",
      criticality: job.criticality || "",
      call_type: job.call_type || "",
      jobs_script: job.jobs_script || "",
      frequency: job.reference_1 || job.frequency || "", // Use reference_1 as frequency
      scope: job.scope || "",
      process_type: job.process_type || "",
      comments: job.comments || "",
      active_flag: job.active_flag ? parseInt(job.active_flag) : 1,
      reference_2: job.reference_2 || "",
      log_file_loc: job.log_file_loc || "",
      master_file: job.master_file || "",
      master_file_loc: job.master_file_loc || "",
    };

    // Set both formData and originalFormData with the same structure
    setFormData(editFormData);
    setOriginalFormData({ ...editFormData }); // Store original data for comparison
    setIsFormChanged(false); // Reset change flag

    setOpenDialog(true);
  };

  const handleDeleteClick = (job) => {
    setSelectedJobForDelete(job);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    if (!selectedJobForDelete) return;

    try {
      await apiService.delete(
        `/jobs/${selectedJobForDelete.job_id}?cl_id=${selectedJobForDelete.cl_id}&env_id=${selectedJobForDelete.env_id}&app_id=${selectedJobForDelete.app_id}`
      );

      setSuccessMessage("Job deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);

      fetchJobs();
      setOpenDeleteDialog(false);
      setSelectedJobForDelete(null);
    } catch (error) {
      setOpenDeleteDialog(false);
      setSelectedJobForDelete(null);
      
      // Use centralized error handler
      const errorMessage = handleDeleteError(error, "Job");
      setErrorMessage(errorMessage);
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  const cancelDelete = () => {
    setOpenDeleteDialog(false);
    setSelectedJobForDelete(null);
  };

  const handleDialogOpen = () => {
    resetFormData();
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const columns = [
    "client_name",
    "environment_name",
    "application_name",
    "client_job_id",
    "job_id",
    "logical_name",
    "criticality",
    "jobs_script",
    "call_type",
    "reference_1",
    "scope",
    "process_type",
    "reference_2",
    "log_file_loc",
    "master_file",
    "master_file_loc",
  ];
  const handleToggleFlag = async (job, active_flag) => {
    try {
      const newFlag = active_flag === 1 ? 0 : 1;
      await apiService.put(`/jobs/${job.job_id}`, {
        cl_id: job.cl_id,
        env_id: job.env_id,
        app_id: job.app_id,
        lg_id: job.lg_id,
        active_flag: newFlag,
      });

      fetchJobs();
      
      // Show success message
      const message = newFlag === 1 
        ? "Job Activated" 
        : "Job Deactivated";
      setSuccessMessage(message);
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error toggling active flag:", error);
      // Use centralized error handler
      const errorMessage = handleToggleError(error, "Job");
      setErrorMessage(errorMessage);
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ width: "100%", maxWidth: "none" }}
    >
      {/* Header: Title and Action Buttons on the SAME line */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        {/* Jobs Title */}
        <Typography
          variant="h4"
          fontSize="25px"
          fontWeight="600"
          color="#454545"
          sx={{ mb: 0 }}
        >
          Jobs/Process
        </Typography>

        {/* Right side: Buttons + Pagination all on the same line */}
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent="space-between"
          sx={{ mb: 0 }}
        >
          {/* Action Buttons Group */}
          <Box display="flex" alignItems="center" gap={0.25} flexWrap="nowrap">
            {/* Search Input */}
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              sx={{
                width: "200px",
                mr: 1,
                "& .MuiInputBase-root": {
                  height: 35,
                },
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.75rem",
                },
              }}
              InputLabelProps={{ shrink: true }}
            />

            {/* Add + */}
            <Button
              onClick={handleDialogOpen}
              sx={{
                color: "#666",
                fontWeight: "bold",
                borderRadius: "8px",
                height: "35px",
                minWidth: "50px",
                px: 1.5,
                textTransform: "none",
                fontSize: "12px",
                "&:hover": {
                  color: "#1976d2",
                },
              }}
            >
              Add +
            </Button>

            {/* Settings */}
            <Tooltip title="Column Customization" arrow>
              <IconButton
                onClick={handleOpen}
                sx={{
                  color: "#666",
                  height: "35px",
                  width: "30px",
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              >
                <SettingsIcon style={{ width: 17, height: 17 }} />
              </IconButton>
            </Tooltip>

            {/* Left Arrow - Smaller button */}
            <IconButton
              onClick={() => {
                if (page > 1) setPage(page - 1);
              }}
              disabled={page <= 1}
              size="small"
              sx={{
                width: "30px",
                height: "35px",
                borderRadius: "6px",
                color: "#666",
                "&:hover": {
                  color: "#1976d2",
                },
                "&:disabled": {
                  color: "#ccc",
                },
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </IconButton>

            {/* Compact Pagination Text */}
            <Box
              sx={{
                fontSize: "13px",
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                whiteSpace: "nowrap",
                fontWeight: 500,
              }}
            >
              {`${(page - 1) * rowsPerPage + 1}-${Math.min(
                page * rowsPerPage,
                total,
              )} of ${total}`}
            </Box>

            {/* Right Arrow - Smaller button */}
            <IconButton
              onClick={() => {
                const totalPages = Math.ceil(total / rowsPerPage);
                if (page < totalPages) setPage(page + 1);
              }}
              disabled={page >= Math.ceil(total / rowsPerPage)}
              size="small"
              sx={{
                width: "30px",
                height: "35px",
                borderRadius: "6px",
                color: "#666",
                "&:hover": {
                  color: "#1976d2",
                },
                "&:disabled": {
                  color: "#ccc",
                },
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </IconButton>
          </Box>
        </Box>
      </Box>

      {/* Alerts (success/error) - placed right below the header */}
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            p: 1,
            width: 230,
            maxHeight: 300,
            overflowY: "auto",
            borderRadius: 2,
          },
        }}
      >
        {Object.keys(visibleColumns).map((col) => (
          <MenuItem key={col} disableGutters sx={{ p: 0, mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: 1.5,
                px: 2,
                py: 1,
                backgroundColor: "#fff",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  color: "#333",
                  fontWeight: "Bold",
                }}
              >
                {columnLabels[col] || col}
              </Typography>

              <Switch
                size="small"
                checked={visibleColumns[col]}
                onChange={(e) =>
                  setVisibleColumns((prev) => ({
                    ...prev,
                    [col]: e.target.checked,
                  }))
                }
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#2DB0E4",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#2DB0E4",
                  },
                }}
              />
            </Box>
          </MenuItem>
        ))}
      </Menu>

      <Box
        sx={{
          height: "calc(90vh - 90px)",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <ThemeProvider theme={Table_theme}>
          <CssBaseline />
          <Paper elevation={3}>
            <TableContainer
              sx={{
                flexGrow: 1,
                maxHeight: "calc(100vh - 260px)",
                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Actions</TableCell>
                    {columns.map((column) =>
                      visibleColumns[column] ? (
                        <TableCell key={column}>
                          <Box display="flex" alignItems="center">
                            {columnLabels[column] || column}
                            <IconButton
                              size="small"
                              onClick={(e) => handleFilterIconClick(e, column)}
                            >
                              <FilterListIcon fontSize="small" />
                            </IconButton>

                            <Popover
                              open={Boolean(filterAnchorEls[column])}
                              anchorEl={filterAnchorEls[column]}
                              onClose={() => handleFilterClose(column)}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                            >
                              <DialogContent>
                                <TextField
                                  label={`Filter ${columnLabels[column] || column}`}
                                  value={tempFilters[column] || ""}
                                  onChange={(e) =>
                                    setTempFilters((prev) => ({
                                      ...prev,
                                      [column]: e.target.value,
                                    }))
                                  }
                                  fullWidth
                                  size="small"
                                />

                                <DialogActions>
                                  <Button onClick={() => clearFilter(column)}>
                                    Clear
                                  </Button>

                                  <Button
                                    onClick={() => applyFilter(column)}
                                    variant="contained"
                                  >
                                    Filter
                                  </Button>
                                </DialogActions>
                              </DialogContent>
                            </Popover>
                          </Box>
                        </TableCell>
                      ) : null,
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell 
                        colSpan={17} 
                        sx={{ 
                          position: "sticky",
                          left: 0,
                          textAlign: "left", 
                          padding: "20px",
                          backgroundColor: "white",
                          zIndex: 1
                        }}
                      >
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : data.length > 0 ? (
                    data.map((job) => (
                      <TableRow key={job.job_id}>
                        <TableCell>
                          <Box
                            display="flex"
                            gap={1}
                            alignItems="center"
                            justifyContent="flex-start"
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleToggleFlag(
                                  job,
                                  parseInt(job.active_flag),
                                )
                              }
                              title="Toggle Active Flag"
                              sx={{
                                "&:hover": {
                                  backgroundColor: "rgba(0,0,0,0.04)",
                                },
                              }}
                            >
                              <FlagIcon
                                style={{
                                  color:
                                    parseInt(job.active_flag) === 1
                                      ? "#00CC22"
                                      : "#FF0C0C",
                                  transition: "color 0.2s",
                                  width: 17,
                                  height: 17,
                                  verticalAlign: "middle",
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(job)}
                              title="Edit"
                              sx={{
                                color: "#2DB0E4",
                                "&:hover": { color: "#1976d2" },
                              }}
                            >
                              <EditOutlined sx={{ fontSize: "16px" }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteClick(job)}
                              title="Delete"
                              sx={{
                                color: "#666",
                                "&:hover": { color: "#d32f2f" },
                              }}
                            >
                              <DeleteIcon
                                style={{
                                  width: 12,
                                  height: 15,
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>

                            <Tooltip title="Schedule">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setSelectedJobForSchedule(job);
                                  setOpenScheduleDialog(true);
                                }}
                                sx={{
                                  color: "#666",
                                  "&:hover": { color: "#1976d2" },
                                }}
                              >
                                <Schedule width={16} height={16} />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Substage">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setSelectedJobForSubstage(job);
                                  setOpenSubstageDialog(true);
                                }}
                                sx={{
                                  color: "#666",
                                  "&:hover": { color: "#1976d2" },
                                }}
                              >
                                <Substage width={16} height={16} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                        {visibleColumns.client_name && (
                          <TableCell>{job.client_name}</TableCell>
                        )}
                        {visibleColumns.environment_name && (
                          <TableCell>{job.environment_name}</TableCell>
                        )}
                        {visibleColumns.application_name && (
                          <TableCell>{job.application_name}</TableCell>
                        )}
                        {visibleColumns.client_job_id && (
                          <TableCell>{job.client_job_id}</TableCell>
                        )}
                        {visibleColumns.job_id && (
                          <TableCell>{job.job_id}</TableCell>
                        )}
                        {visibleColumns.logical_name && (
                          <TableCell>{job.logical_name}</TableCell>
                        )}
                        {visibleColumns.criticality && (
                          <TableCell>{job.criticality}</TableCell>
                        )}
                        {visibleColumns.jobs_script && (
                          <TableCell>{job.jobs_script}</TableCell>
                        )}
                        {visibleColumns.call_type && (
                          <TableCell>{job.call_type}</TableCell>
                        )}
                        {visibleColumns.reference_1 && (
                          <TableCell>{job.reference_1}</TableCell>
                        )}
                        {visibleColumns.scope && (
                          <TableCell>{job.scope}</TableCell>
                        )}
                        {visibleColumns.process_type && (
                          <TableCell>{job.process_type}</TableCell>
                        )}
                        {visibleColumns.reference_2 && (
                          <TableCell>{job.reference_2}</TableCell>
                        )}
                        {visibleColumns.log_file_loc && (
                          <TableCell>{job.log_file_loc}</TableCell>
                        )}
                        {visibleColumns.master_file && (
                          <TableCell>{job.master_file}</TableCell>
                        )}
                        {visibleColumns.master_file_loc && (
                          <TableCell>{job.master_file_loc}</TableCell>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell 
                        colSpan={17} 
                        sx={{ 
                          position: "sticky",
                          left: 0,
                          textAlign: "left", 
                          padding: "20px",
                          backgroundColor: "white",
                          zIndex: 1
                        }}
                      >
                        No matching data found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </ThemeProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Dialog
            open={openDialog}
            // onClose={handleDialogClose}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return;
              setOpenDialog(false);
            }}
            width="small"
            maxWidth="md"
          >
            <DialogTitle
              sx={{
                fontWeight: "700",
                fontSize: "16px",
                py: 1,
              }}
            >
              {isEditing ? "Edit Job/Process" : "Add Job/Process"}
              <IconButton
                aria-label="close"
                onClick={handleDialogClose}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 2 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: 1,
                }}
              >
                {/* CLIENT */}
                <TextField
                  label="Client"
                  value={
                    formData.client_name ||
                    clients.find((c) => c.cl_id === formData.cl_id)?.name ||
                    ""
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                     minWidth: 300,
                    backgroundColor: "white",

                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                      color: "grey",
                    },
                  }}
                  fullWidth
                  margin="none"
                />

                {/* Environment */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.env_id}
                >
                  <Autocomplete
                    id="env_id"
                    options={environments}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      environments.find(
                        (env) => env.env_id === formData.env_id,
                      ) || null
                    }
                    onChange={handleEnvironmentChange}
                    ListboxProps={{
                      sx: {
                        "& .MuiAutocomplete-option": {
                          fontSize: "0.875rem",
                          minHeight: "32px",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Environment"
                        error={!!formErrors.env_id}
                        required
                        helperText={formErrors.env_id}
                      />
                    )}
                    disabled={environments.length === 0}
                  />
                </FormControl>

                {/* Application */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.app_id}
                >
                  <Autocomplete
                    id="app_id"
                    options={applications}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      applications.find(
                        (app) => app.app_id === formData.app_id,
                      ) || null
                    }
                    onChange={handleApplicationChange}
                    ListboxProps={{
                      sx: {
                        "& .MuiAutocomplete-option": {
                          fontSize: "0.875rem",
                          minHeight: "32px",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Application"
                        error={!!formErrors.app_id}
                        required
                        helperText={formErrors.app_id || !formData.env_id}
                      />
                    )}
                    disabled={
                      !formData.env_id || applications.length === 0 || loading
                    }
                    noOptionsText={
                      !formData.env_id
                        ? "Please select an environment first"
                        : "No applications available"
                    }
                  />
                </FormControl>

                {/* Job ID */}
                <TextField
                  label="Job ID"
                  name="job_id"
                  value={formData.job_id}
                  onChange={(e) => handleChange(e)}
                  required
                  fullWidth
                  margin="none"
                  error={!!formErrors.job_id}
                  helperText={
                    formErrors.job_id || (formData.app_id && !isEditing)
                  }
                  disabled={loading || isEditing}
                  InputProps={{
                    readOnly: isEditing,
                  }}
                  sx={isEditing ? {
                    backgroundColor: "white",
                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                      color: "grey",
                    },
                    "& .MuiInputBase-root": {
                      backgroundColor: "white",
                    },
                  } : {}}
                />

                {/* Client Job ID */}
                <TextField
                  label="Client Job ID"
                  name="client_job_id"
                  value={formData.client_job_id}
                  onChange={handleChange}
                  fullWidth
                  margin="none"
                  error={!!formErrors.client_job_id}
                  helperText={formErrors.client_job_id}
                />

                {/* Logical Group */}
                <FormControl fullWidth margin="none" error={!!formErrors.lg_id}>
                  <Autocomplete
                    id="lg_id"
                    options={logicalGroups}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      logicalGroups.find(
                        (group) => group.lg_id === formData.lg_id,
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        lg_id: newValue ? newValue.lg_id : "",
                      }));
                      setFormErrors((prev) => ({ ...prev, lg_id: "" }));
                    }}
                    ListboxProps={{
                      sx: {
                        "& .MuiAutocomplete-option": {
                          fontSize: "0.875rem",
                          minHeight: "32px",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Logical Group"
                        error={!!formErrors.lg_id}
                        required
                        helperText={formErrors.lg_id || !formData.app_id}
                      />
                    )}
                    disabled={!formData.app_id || logicalGroups.length === 0}
                    noOptionsText={
                      !formData.app_id
                        ? "Please select an application first"
                        : "No logical groups available"
                    }
                  />
                </FormControl>

                {/* Criticality */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.criticality}
                >
                  <InputLabel required>Criticality</InputLabel>
                  <Select
                    name="criticality"
                    value={formData.criticality || ""}
                    onChange={handleChange}
                    required
                    label="Criticality *"
                  >
                    <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                      <em>Select Criticality</em>
                    </MenuItem>
                    {[1, 2, 3, 4, 5].map((val) => (
                      <MenuItem
                        key={val}
                        value={val}
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {val}
                      </MenuItem>
                    ))}
                  </Select>
                  {formErrors.criticality && (
                    <Typography color="error" variant="caption">
                      {formErrors.criticality}
                    </Typography>
                  )}
                </FormControl>

                {/* Job Script */}
                <TextField
                  label="Job/Process Name"
                  name="jobs_script"
                  value={formData.jobs_script}
                  onChange={handleChange}
                  required
                  sx={{ mt: -0.05 }}
                  fullWidth
                  margin="none"
                  error={!!formErrors.jobs_script}
                  helperText={formErrors.jobs_script}
                />

                {/* Call Type */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.call_type}
                >
                  <InputLabel>Mode</InputLabel>
                  <Select
                    name="call_type"
                    value={formData.call_type}
                    onChange={handleChange}
                    label="Call Type"
                  >
                    <MenuItem value="Manual" sx={{ fontSize: "0.875rem" }}>
                      Manual
                    </MenuItem>
                    <MenuItem value="Automate" sx={{ fontSize: "0.875rem" }}>
                      AI
                    </MenuItem>
                  </Select>
                  {formErrors.call_type && (
                    <Typography color="error" variant="caption">
                      {formErrors.call_type}
                    </Typography>
                  )}
                </FormControl>

                {/* Frequency */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.frequency}
                >
                  <InputLabel required>Frequency</InputLabel>
                  <Select
                    name="frequency"
                    value={formData.frequency || ""}
                    onChange={handleChange}
                    required
                    label="Frequency *"
                  >
                    <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                      <em>Select Frequency</em>
                    </MenuItem>
                    {[
                      "Mon-Sat",
                      "Mon-Fri",
                      "Sun",
                      "Sun-Fri",
                      "Daily",
                      "Fri",
                      "Sat",
                      "Tue-Sat",
                      "Mon",
                      "Wed",
                      "Tue",
                      "Thur",
                      "Weekly",
                      "Monthly",
                    ].map((freq) => (
                      <MenuItem
                        key={freq}
                        value={freq}
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {freq}
                      </MenuItem>
                    ))}
                  </Select>
                  {formErrors.frequency && (
                    <Typography color="error" variant="caption">
                      {formErrors.frequency}
                    </Typography>
                  )}
                </FormControl>

                {/* Scope */}
                <FormControl fullWidth margin="none" error={!!formErrors.scope}>
                  <InputLabel required>Scope</InputLabel>
                  <Select
                    name="scope"
                    value={formData.scope || ""}
                    onChange={handleChange}
                    required
                    label="Scope *"
                  >
                    <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                      <em>Select Scope</em>
                    </MenuItem>
                    <MenuItem value="Undefined" sx={{ fontSize: "0.875rem" }}>
                      Undefined
                    </MenuItem>
                    <MenuItem value="Evening Job" sx={{ fontSize: "0.875rem" }}>
                      Evening Job
                    </MenuItem>
                    <MenuItem value="Night Job" sx={{ fontSize: "0.875rem" }}>
                      Night Job
                    </MenuItem>
                    <MenuItem value="Other Jobs" sx={{ fontSize: "0.875rem" }}>
                      Other Jobs
                    </MenuItem>
                    <MenuItem value="Email" sx={{ fontSize: "0.875rem" }}>
                      Email
                    </MenuItem>
                    <MenuItem value="API" sx={{ fontSize: "0.875rem" }}>
                      API
                    </MenuItem>
                  </Select>
                  {formErrors.scope && (
                    <Typography color="error" variant="caption">
                      {formErrors.scope}
                    </Typography>
                  )}
                </FormControl>

                {/* Process Type */}
                <FormControl
                  fullWidth
                  margin="none"
                  error={!!formErrors.process_type}
                >
                  <InputLabel required>Process Type</InputLabel>
                  <Select
                    name="process_type"
                    value={formData.process_type || ""}
                    onChange={handleChange}
                    required
                    label="Process Type *"
                  >
                    <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                      <em>Select Process Type</em>
                    </MenuItem>
                    <MenuItem
                      value="Scheduled Process"
                      sx={{ fontSize: "0.875rem" }}
                    >
                      Scheduled Process
                    </MenuItem>
                    <MenuItem value="Sub Process" sx={{ fontSize: "0.875rem" }}>
                      Sub Process
                    </MenuItem>
                    <MenuItem
                      value="Event Listener"
                      sx={{ fontSize: "0.875rem" }}
                    >
                      Event Listener
                    </MenuItem>
                    <MenuItem value="Automate" sx={{ fontSize: "0.875rem" }}>
                      Automate
                    </MenuItem>
                    <MenuItem value="Manual" sx={{ fontSize: "0.875rem" }}>
                      Manual
                    </MenuItem>
                  </Select>
                  {formErrors.process_type && (
                    <Typography color="error" variant="caption">
                      {formErrors.process_type}
                    </Typography>
                  )}
                </FormControl>
                <TextField
                  label="Folder"
                  name="reference_2"
                  value={formData.reference_2}
                  onChange={handleChange}
                  sx={{ mt: 0.8 }}
                  fullWidth
                  margin="none"
                  error={!!formErrors.reference_2}
                  helperText={formErrors.reference_2}
                />
                <TextField
                  label="Log File "
                  name="log_file_loc"
                  value={formData.log_file_loc}
                  onChange={handleChange}
                  sx={{ mt: 0.8 }}
                  fullWidth
                  margin="none"
                  error={!!formErrors.log_file_loc}
                  helperText={formErrors.log_file_loc}
                />
                <TextField
                  label="Master File"
                  name="master_file"
                  value={formData.master_file}
                  onChange={handleChange}
                  sx={{ mt: 0.8 }}
                  fullWidth
                  margin="none"
                  error={!!formErrors.master_file}
                  helperText={formErrors.master_file}
                />
                <TextField
                  label="Master File Location"
                  name="master_file_loc"
                  value={formData.master_file_loc}
                  onChange={handleChange}
                  sx={{ mt: -0.05 }}
                  fullWidth
                  margin="none"
                  error={!!formErrors.master_file_loc}
                  helperText={formErrors.master_file_loc}
                />

                {/* Comments */}
                
              </Box>
              <TextField
                  label="Comments"
                  name="comments"
                  value={formData.comments}
                  onChange={handleChange}
                                    sx={{
                                     gridColumn: "span 2", 
                     minWidth: 300, 
                    ...compactMultilineStyles,
                            width: "100%",
                   }}
                   multiline
                          rows={2}
                  margin="none"
                  error={!!formErrors.comments}
                  helperText={formErrors.comments}
                />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose}>Cancel</Button>
              <Button 
                onClick={handleSubmit} 
                variant="contained"
                disabled={isEditing && !isFormChanged}
              >
                {isEditing ? "Update" : "Add"}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openDeleteDialog}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return;
              cancelDelete();
            }}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle sx={{ fontWeight: "bold", fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif" }}>
              Confirm Delete
            </DialogTitle>

            <DialogContent>
              <Typography fontSize="0.9rem">
                Are you sure you want to delete Job{" "}
                <strong>
                  {selectedJobForDelete?.jobs_script ||
                    selectedJobForDelete?.job_id}
                </strong>{" "}
                ?
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button onClick={cancelDelete} sx={{ fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif" }}>Cancel</Button>

              <Button variant="contained" onClick={confirmDelete} sx={{ fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif" }}>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>

          <ScheduleForm
            open={openScheduleDialog}
            handleClose={() => setOpenScheduleDialog(false)}
            selectedBJob={selectedJobForSchedule}
          />
          <SubStageForm
            open={openSubstageDialog}
            handleClose={() => setOpenSubstageDialog(false)}
            selectedBJob={selectedJobForSubstage}
          />
        </ThemeProvider>
      </Box>
    </Container>
  );
}

export default Jobs_panel;
